import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { images } from "../assets/images";
import { BackgroundMedia } from "./BackgroundMedia";

export function SolutionSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section
      id="solution"
      ref={ref}
      className="relative min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-blue-50 py-32 px-6"
    >
      <div className="max-w-7xl w-full">
        {/* 标题区域 */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="text-center mb-20"
        >
          <motion.div
            initial={{ scaleX: 0 }}
            animate={isInView ? { scaleX: 1 } : { scaleX: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="h-1 w-24 bg-blue-600 mx-auto mb-8"
          />
          <h2 className="text-zinc-800 text-xl md:text-3xl lg:text-4xl">善行足迹</h2>
        </motion.div>

        {/* 单张照片展示 */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
          transition={{ duration: 0.8, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-5xl mx-auto"
        >
          <div className="relative aspect-[16/10] overflow-hidden rounded-3xl shadow-2xl group">
            <BackgroundMedia
              videoSrc={images.hope}
              imageSrc={images.hopeImage}
              className="w-full h-full object-cover transition-all duration-700 group-hover:scale-105"
            />
            
            {/* 渐变遮罩 */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent" />
            
            {/* 文字内容 */}
            <div className="absolute inset-0 flex flex-col justify-end items-center text-center p-8 md:p-12 pb-12 md:pb-16">
              <motion.h3
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.8, delay: 0.6 }}
                className="text-white text-xl md:text-3xl lg:text-4xl leading-relaxed drop-shadow-lg"
              >
                <span className="block mb-2">今日播种希望的种子</span>
                <span className="block">明日长成和平的森林</span>
              </motion.h3>
              
              {/* 装饰线 */}
              <motion.div
                initial={{ scaleX: 0 }}
                animate={isInView ? { scaleX: 1 } : { scaleX: 0 }}
                transition={{ duration: 0.8, delay: 0.8 }}
                className="mt-6 h-0.5 w-24 bg-white/80 origin-center"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

